import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Creditnotes/Print/templates/*/index.tsx"
);

type CreditnotePrintProps = {
};

export default function CreditnotePrint(props: CreditnotePrintProps) {
  return (
    <TenantTemplateRouterCore<CreditnotePrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}